import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  GoogleMapBounds,
  GoogleMapElement,
  parseMapBounds,
  useDomains,
  useToggleLocation,
} from '@schamburg-web/components';
import {
  EmailControl,
  LayerControl,
  MapTypeControl,
  SideBarControl,
  ZoomControl,
} from '@schamburg-web/lakecounty';
import { ControlPosition, MapProps } from '@vis.gl/react-google-maps';
import React, { useMemo } from 'react';

const mapOptions = {
  defaultCenter: { lat: 42.32, lng: -88.05 },
  defaultZoom: 11,
  minZoom: 10,
  maxZoom: 16,
  disableDefaultUI: true,
} as MapProps;

const mapBounds = parseMapBounds(
  import.meta.env.VITE_REACT_APP_MAP_MIN_ZOOM,
  import.meta.env.VITE_REACT_APP_MAP_BOUNDS,
  import.meta.env.VITE_REACT_APP_MAP_CENTER
);

const LcMap: React.FC = () => {
  const { domains } = useDomains();
  const { locationEnabled, setLocationEnabled } = useToggleLocation();

  const apiKey = useMemo(() => {
    return domains.find((d) => d.name === 'extWebsite.apikey')?.value;
  }, [domains]);

  if (undefined !== apiKey) {
    return (
      <GoogleMapElement
        apiKey={apiKey}
        mapOptions={mapOptions}
        locationEnabled={locationEnabled}
        setLocationEnabled={setLocationEnabled}
      >
        {mapBounds && <GoogleMapBounds bounds={mapBounds} />}
        <MapTypeControl
          controlPosition={ControlPosition.RIGHT_TOP}
        ></MapTypeControl>
        <LayerControl
          controlPosition={ControlPosition.RIGHT_TOP}
        ></LayerControl>
        <SideBarControl
          controlPosition={ControlPosition.LEFT_TOP}
        ></SideBarControl>
        <EmailControl
          controlPosition={ControlPosition.RIGHT_BOTTOM}
        ></EmailControl>
        <ZoomControl
          controlPosition={ControlPosition.RIGHT_BOTTOM}
        ></ZoomControl>
      </GoogleMapElement>
    );
  } else if (domains.length > 0) {
    return (
      <Box sx={{ width: '100%', height: '100%' }}>
        <Typography variant="h5" color="error" sx={{ p: 2 }}>
          Google Maps API key not found. Please contact your administrator.
        </Typography>
      </Box>
    );
  } else {
    return (
      <CircularProgress
        sx={{ margin: 'auto', display: 'block', marginTop: '20px' }}
      />
    );
  }
};

export default LcMap;
